var map = {
	"./01d.png": 2013,
	"./01n.png": 2014,
	"./02d.png": 2015,
	"./02n.png": 2016,
	"./03d.png": 2017,
	"./03n.png": 2018,
	"./04d.png": 2019,
	"./04n.png": 2020,
	"./09d.png": 2021,
	"./09n.png": 2022,
	"./10d.png": 2023,
	"./10n.png": 2024,
	"./11d.png": 2025,
	"./11n.png": 2026,
	"./13d.png": 2027,
	"./13n.png": 2028,
	"./50d.png": 2029,
	"./50n.png": 2030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;